exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".YnPvg6klpvTv3sYT4syS1{min-width:276px}.S2ItkNNitN9z3dYGzzPgG{width:100%}html[dir] .S2ItkNNitN9z3dYGzzPgG{margin-top:15px}", ""]);
// Exports
exports.locals = {
	"menuFeedback": "YnPvg6klpvTv3sYT4syS1",
	"sendButton": "S2ItkNNitN9z3dYGzzPgG"
};